import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M12 24c6.627 0 12-5.373 12-12 0-2.014-.497-3.912-1.373-5.578l-10.641 5.592 5.592-10.64A11.95 11.95 0 0 0 12 0C5.373 0 0 5.373 0 12c0 3.314 1.343 6.314 3.515 8.485A11.96 11.96 0 0 0 12 24"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M22.613 6.434a12 12 0 0 0-2.142-2.906c-.88-.879-1.861-1.593-2.907-2.142L3.5 20.499z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF9811",
  d: "M3.5 20.5 22.613 6.434a12 12 0 0 0-2.142-2.906z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "m10.42 7.037-1.466.69.78 1.419-1.591-.305-.202 1.608-1.108-1.183-1.109 1.183-.201-1.608-1.592.305.78-1.42-1.465-.69 1.466-.688-.78-1.42 1.59.305.202-1.608 1.109 1.182L7.94 3.625l.202 1.608 1.591-.305-.78 1.42z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }